exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.id, ".footer {\n  padding-bottom: 20px; }\n  .footer .wrapper {\n    border-top: 1px solid #ededed; }\n  .footer__menu {\n    display: flex;\n    justify-content: inherit;\n    align-items: inherit;\n    padding-top: 20px; }\n    .footer__menu .button {\n      color: #12111f; }\n      .footer__menu .button:hover, .footer__menu .button:focus {\n        text-decoration: none;\n        color: #408bfa; }\n    .footer__menu-item {\n      margin-right: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/containers/Footer/Footer.scss
// module id = 394
// module chunks = 0